<template>
  <div class="container-f2g black-container">
      <div class="f2g-wind-container">
          <div class="hero-banner-f2g banner-etopup colorful-container">
              <div class="left-side-banner">
                  <div class="mini-title-blue">
                      {{content["myf2g.topupautorechargebanner.subtitle"]}}
                  </div>
                  <div class="text-title-banner">
                      {{content["myf2g.topupautorechargebanner.title"]}}
                  </div>
                  <div class="xs-title-banner">
                      {{content["myf2g.topupautorechargebanner.paragraph1"]}}
                      <br />
                      <br />
                      {{content["myf2g.topupautorechargebanner.paragraph2"]}}
                  </div>
                  <div class="last-element-banner">
                    <a v-on:click="handleCTA()">
                      <div class="container-button  blue-btn button-banner-fontsize cursor-hand">
                          {{content["myf2g.topupautorechargebanner.button"]}}                  
                      </div>
                    </a>
                  </div>
              </div>
              <img src="/ext_files/prepaid/f2g/images/Auto TopUp.png" class="right-side-banner-img hidden-xs hidden-sm" />
          </div>
      </div>
  </div>
</template>


<script>


export default {
  name: "AutoRechargeBanner",
  data: function() {
    return {
      content: '',
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    }
  },
  created() {
    let self = this;

    /************************
     *** WCS service call ***
     ************************/

    let configWCS = {
      sessionKey: "wcs_topup_auto_recharge_banner",
      axiosConfig: {
      method: "get",
        url: '/gr/f2g/vueContentService/',
        params: {
          ciKey: 'myf2gtopupautorechargebanner',
          locale: self.locale
        }
      }
    }

    this.fetchDataFromWCS(configWCS)
        .then(response => {
          console.log(JSON.stringify(response))
          self.content = response
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          console.log("finally");
        });
  },
  methods: {
    handleCTA() {
      this.$store.commit("showSuccessComponent", false);
      this.$store.commit("showErrorComponent", false);
      this.$store.commit("showSavedCardComponent", false);
      this.$store.commit("showAutoRechargeModal", true);
    }
  }
  
}
</script>